<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Принтери B2546, B2650, M1246, MS521, MS621">
     Принтери B2546, B2650, M1246, MS521, MS621
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_bg" title="Информация за безопасност">
     Информация за безопасност
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Правила">
      Правила
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Извлечения за продукта">
      Извлечения за продукта
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_bg" title="Откриване на информация за принтера">
     Откриване на информация за принтера
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_bg" title="Откриване на информация за принтера">
      Откриване на информация за принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_bg" title="Избор на място за принтера">
      Избор на място за принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_bg" title="Конфигурации на принтера">
      Конфигурации на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_bg" title="Свързване на кабели">
      Свързване на кабели
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_bg" title="Използване на контролния панел">
      Използване на контролния панел
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_bg" title="Запознаване със състоянията на бутона за захранване и индикаторната светлина">
      Запознаване със състоянията на бутона за захранване и индикаторната светлина
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_bg" title="Зареждане на хартия и специален носител">
     Зареждане на хартия и специален носител
    </a>
   </p>
   <div id="divd0e735">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_bg" title="Настройка на размера и типа на специални печатни носители">
      Настройка на размера и типа на специални печатни носители
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_bg" title="Конфигуриране на универсални настройки за хартия">
      Конфигуриране на универсални настройки за хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_bg" title="Зареждане на тави">
      Зареждане на тави
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_bg" title="Зареждане на многоцелевото подаващо устройство">
      Зареждане на многоцелевото подаващо устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_bg" title="Свързване на тави">
      Свързване на тави
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_bg" title="Поставка за хартия">
     Поставка за хартия
    </a>
   </p>
   <div id="divd0e933">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_bg" title="Поддържани размери хартия">
      Поддържани размери хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_bg" title="Поддържани типове хартия">
      Поддържани типове хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_bg" title="Поддържано тегло на хартията">
      Поддържано тегло на хартията
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_bg" title="Неприемлива хартия">
      Неприемлива хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_bg" title="Използване на рециклирана хартия">
      Използване на рециклирана хартия
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_bg" title="Отпечатване">
     Отпечатване
    </a>
   </p>
   <div id="divd0e1540">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_bg" title="Отпечатване от компютър">
      Отпечатване от компютър
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1566" title="Отпечатване от мобилно устройство">
      Отпечатване от мобилно устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_bg" title="Отпечатване от флаш устройство">
      Отпечатване от флаш устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_bg" title="Поддържани флаш устройства и типове файлове">
      Поддържани флаш устройства и типове файлове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_bg" title="Отпечатване на списък с примери на шрифтове">
      Отпечатване на списък с примери на шрифтове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_bg" title="Отпечатване на списък на директории">
      Отпечатване на списък на директории
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_bg" title="Запознаване с менютата на принтера">
     Запознаване с менютата на принтера
    </a>
   </p>
   <div id="divd0e1825">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_bg" title="Карта на менюто">
      Карта на менюто
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e2054" title="Устройство">
      Устройство
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e3222" title="Печат">
      Печат
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e4184" title="Хартия">
      Хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4418" title="Мрежа/портове">
      Мрежа/портове
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e5977" title="USB у-во">
      USB у-во
     </a>
    </p>
    <p class="toc-2-style">
     <a href="security-audit-log-topic.html#d0e6140" title="Защита">
      Защита
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e6632" title="Отчети">
      Отчети
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_bg" title="Помощ">
      Помощ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e6816" title="Откриване и отстраняване на неизправности">
      Откриване и отстраняване на неизправности
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_bg" title="Печат на страница с настройки на менюто">
      Печат на страница с настройки на менюто
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_bg" title="Защита на принтера">
     Защита на принтера
    </a>
   </p>
   <div id="divd0e6874">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_bg" title="Намиране на слота за защита">
      Намиране на слота за защита
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_bg" title="Изтриване на паметта на принтера">
      Изтриване на паметта на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_bg" title="Възстановяване на фабричните настройки по подразбиране">
      Възстановяване на фабричните настройки по подразбиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_bg" title="Изявление за енергозависимост">
      Изявление за енергозависимост
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_bg" title="Поддръжка на принтера">
     Поддръжка на принтера
    </a>
   </p>
   <div id="divd0e7042">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e7047" title="Мрежова функционалност">
      Мрежова функционалност
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_bg" title="Почистване на принтера">
      Почистване на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_bg" title="Поръчване на части и консумативи">
      Поръчване на части и консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e7788" title="Замяна на части и консумативи">
      Замяна на части и консумативи
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e7932" title="Преместване на принтера">
      Преместване на принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e7987" title="Пестене на енергия и хартия">
      Пестене на енергия и хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e8113" title="Рециклиране">
      Рециклиране
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_bg" title="Отстраняване на заседнала хартия">
     Отстраняване на заседнала хартия
    </a>
   </p>
   <div id="divd0e8167">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_bg" title="Предотвратяване на засядането">
      Предотвратяване на засядането
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_bg" title="Идентифициране на места на засядане">
      Идентифициране на места на засядане
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_bg" title="Засядане на хартия във врата A">
      Засядане на хартия във врата A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_bg" title="Заседнала хартия в задната вратичка">
      Заседнала хартия в задната вратичка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_bg" title="Заседнала хартия в стандартната изходна тава">
      Заседнала хартия в стандартната изходна тава
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_bg" title="Засядане на хартия в устройството за двустранен печат">
      Засядане на хартия в устройството за двустранен печат
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_bg" title="Заседнала хартия в тавите">
      Заседнала хартия в тавите
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_bg" title="Заседнала хартия в многоцелевото подаващо устройство">
      Заседнала хартия в многоцелевото подаващо устройство
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_bg" title="Откриване и отстраняване на неизправности">
     Откриване и отстраняване на неизправности
    </a>
   </p>
   <div id="divd0e8443">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e8446" title="Проблеми с мрежовата връзка">
      Проблеми с мрежовата връзка
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e8700" title="Проблеми с консумативите">
      Проблеми с консумативите
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_bg" title="Проблеми с подаването на хартия">
      Проблеми с подаването на хартия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_bg" title="Проблеми с печата">
      Проблеми с печата
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_bg" title="Свързване с поддръжка на клиенти">
      Свързване с поддръжка на клиенти
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_bg" title="Надстройване и миграция">
     Надстройване и миграция
    </a>
   </p>
   <div id="divd0e11616">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e11619" title="Хардуер">
      Хардуер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e11809" title="Софтуер">
      Софтуер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e11885" title="Фърмуер">
      Фърмуер
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_bg" title="Известия">
     Известия
    </a>
   </p>
   <div id="divd0e11954">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11957" title="Информация за продукта">
      Информация за продукта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e11974" title="Известие за нова версия">
      Известие за нова версия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_bg" title="Търговски марки">
      Търговски марки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_bg" title="Известия за лицензиране">
      Известия за лицензиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_bg" title="Нива на емисии на шум">
      Нива на емисии на шум
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_bg" title="Директива относно отпадъци от електрическо и електронно оборудване (WEEE)">
      Директива относно отпадъци от електрическо и електронно оборудване (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12076" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_bg" title="Изхвърляне на продукта">
      Изхвърляне на продукта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12110" title="Литиевойонна презареждаема батерия">
      Литиевойонна презареждаема батерия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_bg" title="Регламент (ЕС) 2023/1542">
      Регламент (ЕС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_bg" title="Връщане на касетите на Lexmark за повторна употреба или рециклиране">
      Връщане на касетите на Lexmark за повторна употреба или рециклиране
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_bg" title="Известие за чувствителност към статично електричество">
      Известие за чувствителност към статично електричество
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_bg" title="ENERGY STAR (ЕНЕРГИЙНА ЗВЕЗДА)">
      ENERGY STAR (ЕНЕРГИЙНА ЗВЕЗДА)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_bg" title="Информация за температурата">
      Информация за температурата
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_bg" title="Известие за лазера">
      Известие за лазера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_bg" title="Потребление на енергия">
      Потребление на енергия
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12350" title="Нормативни разпоредби за безжични продукти">
      Нормативни разпоредби за безжични продукти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_bg" title="Известие за модулен компонент">
      Известие за модулен компонент
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_bg" title="Излагане на радиочестотно лъчение">
      Излагане на радиочестотно лъчение
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_bg" title="Съответствие с директиви на Европейската общност (ЕО)">
      Съответствие с директиви на Европейската общност (ЕО)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e12384" title="Съответствие с директиви на Европейската общност (ЕО)">
      Съответствие с директиви на Европейската общност (ЕО)
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue